import { ReactNode, forwardRef } from "react"
import { useTranslation } from "react-i18next"
import { MdAutoStories } from "react-icons/md"
import { HeaderBrandingSeaq } from "./HeaderBrandingSeaq"
type HeaderLayoutProps = {
	label: string
	translationFunc?: ReturnType<typeof useTranslation>["t"]
	children?: ReactNode
	customerName?: string
	onUserManualClick?: () => void
}

const HeaderLayout = forwardRef<HTMLDivElement, HeaderLayoutProps>((props, ref) => {
	const { label, translationFunc, children, customerName, onUserManualClick } = props
	const { t } = useTranslation()

	return (
		<div
			ref={ref}
			className={`bg-dipai-secondary-901 shadow-popup sticky top-0 z-98 flex h-13 w-full flex-row items-center gap-12 border-b-0 border-gray-900 px-5`}
		>
			<div className="flex">
				<p
					id={"header label"}
					className={`text-title5 font-bold whitespace-nowrap text-white/90`}
				>
					{translationFunc !== undefined
						? translationFunc(label.replaceAll("-", " ").toUpperCase())
						: label}
				</p>
			</div>
			<div className={`flex h-13 w-full flex-row justify-between gap-4`}>
				{children}
				{/* fix positioning of branding if there are no other children */}
				{(children === undefined || children === null) &&
				(customerName?.toLowerCase() === "ocean infinity" ||
					customerName?.toLowerCase() === "vard") ? (
					<div className={`h-13 w-full`} />
				) : null}
				{customerName?.toLowerCase() === "ocean infinity" ||
				customerName?.toLowerCase() === "vard" ? (
					<HeaderBrandingSeaq />
				) : null}
			</div>
			<div
				id={"header-user-manual"}
				className={`text-title5 flex animate-[bounce_1s_4] flex-row items-center self-center font-bold whitespace-nowrap text-white/90 ${
					onUserManualClick !== undefined
						? "cursor-pointer transition-opacity hover:opacity-70"
						: "hidden"
				}`}
				onClick={onUserManualClick}
			>
				<MdAutoStories className={`size-6`} />
			</div>
		</div>
	)
})

export { HeaderLayout }
